import Repository from './repository';

/**
   * Constructor
   */
const url = 'users/sync';

const User = {
  syncProfile: payload => Repository.post(url, payload)
};

export default User;
